import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ApplicationSliceState } from './application.type';

const applicationInitialState: ApplicationSliceState = {
    isOnline: true,
};

export const APPLICATION_REDUCER_NAME = 'application';

export const applicationSlice = createSlice({
    name: APPLICATION_REDUCER_NAME,
    initialState: applicationInitialState,
    reducers: {
        setIsOnline: (
            state,
            action: PayloadAction<ApplicationSliceState['isOnline']>,
        ) => {
            state.isOnline = action.payload;
        },
    },
});

export const { setIsOnline } = applicationSlice.actions;

export const applicationReducer = applicationSlice.reducer;
